import React from 'react';
import { motion } from 'framer-motion';
export function MethodSection() {
  return <section className="py-32 px-4 bg-gradient-to-b from-navy-800 via-amber-900/20 to-cream-50 relative overflow-hidden" data-id="element-135">
      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-137">
          <span className="text-amber-400 font-body tracking-wider uppercase text-sm font-bold mb-4 block" data-id="element-138">
            El Mecanismo Único
          </span>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-cream-50 mb-8" data-id="element-139">
            El Método de{' '}
            <span className="text-amber-400" data-id="element-140">Conexión y Pausa</span>
          </h2>

          <div className="bg-navy-900/60 backdrop-blur-sm p-8 md:p-10 rounded-2xl border border-amber-500/20 shadow-2xl text-left" data-id="element-141">
            <p className="text-lg text-cream-100 font-body leading-relaxed mb-6" data-id="element-142">
              Este sistema no ignora al bebé. Al contrario, utiliza la ciencia
              del sistema nervioso para crear un puente de seguridad.
            </p>
            <p className="text-lg text-cream-100 font-body leading-relaxed mb-8" data-id="element-143">
              En lugar de intervenir al primer quejido (lo que interrumpe su
              aprendizaje), aprendes a identificar la "Pausa Sagrada". Es un
              proceso de 3 fases donde el bebé entiende que tú estás ahí, pero
              que él es capaz de cerrar los ojos y descansar por sí mismo
              utilizando los recursos que ya tiene.
            </p>

            <div className="flex justify-center items-center space-x-4 md:space-x-8 pt-6 border-t border-navy-700/50" data-id="element-144">
              <div className="flex flex-col items-center" data-id="element-145">
                <div className="w-10 h-10 rounded-full bg-amber-500/20 flex items-center justify-center text-amber-400 font-bold mb-2" data-id="element-146">
                  1
                </div>
                <span className="text-xs text-cream-200 uppercase tracking-wider" data-id="element-147">
                  Observar
                </span>
              </div>
              <div className="h-px w-12 bg-amber-500/30" data-id="element-148"></div>
              <div className="flex flex-col items-center" data-id="element-149">
                <div className="w-10 h-10 rounded-full bg-amber-500/20 flex items-center justify-center text-amber-400 font-bold mb-2" data-id="element-150">
                  2
                </div>
                <span className="text-xs text-cream-200 uppercase tracking-wider" data-id="element-151">
                  Pausar
                </span>
              </div>
              <div className="h-px w-12 bg-amber-500/30" data-id="element-152"></div>
              <div className="flex flex-col items-center" data-id="element-153">
                <div className="w-10 h-10 rounded-full bg-amber-500/20 flex items-center justify-center text-amber-400 font-bold mb-2" data-id="element-154">
                  3
                </div>
                <span className="text-xs text-cream-200 uppercase tracking-wider" data-id="element-155">
                  Conectar
                </span>
              </div>
            </div>
          </div>

          <a href="#oferta-precio" className="mt-10 inline-block bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-navy-950 font-bold font-body text-lg py-4 px-10 rounded-full shadow-[0_0_20px_rgba(251,191,36,0.4)] hover:shadow-[0_0_30px_rgba(251,191,36,0.6)] transition-all duration-300 animate-pulse-glow transform hover:-translate-y-1" data-id="element-156">
            SÍ, QUIERO QUE MI BEBÉ DUERMA
          </a>
        </motion.div>
      </div>
    </section>;
}